import { render, staticRenderFns } from "./AssignmentResults.vue?vue&type=template&id=1a83da50&scoped=true&"
import script from "./AssignmentResults.vue?vue&type=script&lang=js&"
export * from "./AssignmentResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a83da50",
  null
  
)

export default component.exports